import { render } from "./ChannelsChartCard.vue?vue&type=template&id=01e854a6"
import script from "./ChannelsChartCard.vue?vue&type=script&lang=js"
export * from "./ChannelsChartCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__